<div class="container mt-4">
    <h1 class="heading text-center">Access denied</h1>
    <p class="text-center mt-2">You dont have permission to access this page</p>
</div>
<div class="d-flex justify-content-center mt-4">
    <button class="back-button" (click)="goBack();">Go back</button>
</div>